module.exports = __webpack_public_path__ + "static/media/ENFJ.0787b342.png";